"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSPrimaryPaymentMethodComponent = void 0;
const accountsettings_service_1 = require("../../services/accountsettings.service");
const account_service_1 = require("../../services/account.service");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
const _ = require("underscore");
const generic_content_service_1 = require("../../services/generic.content.service");
const roles_helper_service_1 = require("../../services/roles-helper.service");
const constants_1 = require("../../constants");
class CSPrimaryPaymentMethodComponent {
    constructor(accountDetailService, accountService, genericContentService, rolesService) {
        this.accountDetailService = accountDetailService;
        this.accountService = accountService;
        this.genericContentService = genericContentService;
        this.rolesService = rolesService;
        this.isSecondary = false;
        this.isProspect = false;
        this.roles = constants_1.UserRole;
    }
    ngOnInit() {
        this.getAccountDetailsInfo();
        this.showForm = true;
        this.getErrorMessage();
    }
    getAccountDetailsInfo() {
        this.accountService.getAccountDetails().subscribe((res) => {
            this.isBusinessAccount = res.businessAccount;
            this.isProspect = res.prospectProfile;
            this.showEdit = true;
            if (res.profileType === 'SECONDARY') {
                this.isSecondary = true;
            }
            this.isPrepaidAcc = res.advancePayAccount;
            if (this.isPrepaidAcc) {
                const subscription = res.subscription;
                const primarySub = _.find(subscription, function (sub) {
                    return sub.primarySubOnAccount != null;
                });
                if (primarySub === undefined) {
                    this.showEdit = false;
                }
            }
            if (!this.isProspect) {
                this.getPaymentMethod();
            }
        });
    }
    getPaymentMethod() {
        this.loader = true;
        this.paymentType = 'bank';
        this.accountDetailService.getPaymentMethodInformation().subscribe((info) => {
            this.paymentInfo = info;
            this.loader = false;
            if ((this.paymentInfo && (this.paymentInfo.bankAccount == null && this.paymentInfo.card == null)) ||
                this.paymentInfo == null) {
                this.noPrimary = true;
                this.getSavedCardDetails(true);
            }
            else {
                if (this.paymentInfo.paymentType === 'credit') {
                    this.getSavedCardDetails();
                }
                else {
                    this.getSavedCardDetails();
                    this.saveBankData = this.paymentInfo.bankAccount;
                }
                this.showEmptyMsg = false;
                this.paymentInfo = info;
            }
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    getErrorMessage() {
        this.loader = true;
        this.accountService.getCSErrorMessage().subscribe((res) => {
            this.loader = false;
            this.feErrorMsg = res;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    // Fetch Saved card
    getSavedCardDetails(noPrimary) {
        this.loader = true;
        this.accountService.getPrimarySavedCards().subscribe((res) => {
            this.cardDetails = res;
            if (res == null && noPrimary) {
                this.getSavedBankAccount();
            }
            this.cardDetails = _.sortBy(this.cardDetails, 'defaultCard').reverse();
            this.loader = false;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    // To get the saved bank details from
    getSavedBankAccount() {
        this.loader = true;
        this.bankOnly = true;
        this.accountService.getPrimarySavedBankDetails().subscribe((data) => {
            if (!data) {
                this.bankOnly = false;
                this.showEmptyMsg = true;
            }
            this.loader = false;
            this.saveBankData = data;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    openTooltip() {
        this.primarypaymenttooltip.open();
    }
    closeTooltip() {
        this.primarypaymenttooltip.close();
    }
    tooltipForPrimaryPayment() {
        this.genericContentService.getGenericContent('genericContentPrimaryPayment').subscribe((data) => {
            this.primaryPaymentContent = data;
        }, (err) => {
            this.error = err;
        });
    }
    addPyamentMethod() {
        if (this.isPrepaidAcc) {
            location.href = '/my_account/personal/#/prepaid/account-settings/payment-method';
        }
        else if (this.isBusinessAccount) {
            location.href = '/my_account/personal/#/business/account-settings/payment-method';
        }
        else {
            location.href = '/my_account/personal/#/wireless/account-settings/payment-method';
        }
    }
    showRoles(roles) {
        return this.rolesService.getRolesPermission(roles, true);
    }
}
exports.CSPrimaryPaymentMethodComponent = CSPrimaryPaymentMethodComponent;
//# sourceMappingURL=paymentmethod.component.js.map